import { defineComponent as _defineComponent } from 'vue'
import './SearchModeTag.scss';
import { SearchMode } from '@/@types/SearchMode';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchModeTag',
  props: {
    searchMode: null
  },
  emits: ["remove"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'remove', value: boolean): boolean;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  searchMode: SearchMode;
}





const isAi = computed(() => props.searchMode === SearchMode.AI);

const tagTitle = computed((): string => {
  switch (props.searchMode) {
    case SearchMode.AI:
      return 'Snaplore';
    default:
      return '';
  }
});

const removeSearchMode = () => {
  emit('remove', true);
  return;
};

return { __sfc: true,props, emit, isAi, tagTitle, removeSearchMode }
}

})